import { _ as B } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import { c as I } from "./index-8b07dec9.js";
import { useContext as w, useRef as W, createElement as q, useLayoutEffect as O } from "react";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import { _ as E } from "./cloneSlots-622cf8c9.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import { useResizeObserver as R } from "./useResizeObserver.js";
import "./useScroll.js";
import { useSlots as S } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { FocusTrap as D } from "./focusTrap.js";
import { Carousel as F } from "./carousel.js";
import _, { css as h } from "styled-components";
import "./index-5d0f31c6.js";
import { jsxs as P, jsx as b } from "react/jsx-runtime";
import "./es.string.trim-6e13db75.js";
import "./label.js";
import "./es.array.from-fe752fa6.js";
import "./es.function.name-b230e7d4.js";
import "./index-f5b44da3.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import { T as $ } from "./tabs.provider-ae82732d.js";
import { Badge as V } from "./badge.js";
import "./es.array.is-array-7a29277f.js";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./isApiSupported-66660265.js";
import "./isClient-2f5bedbd.js";
import "./useIsMounted.js";
import "./useEventListener.js";
import "./useOverFlown.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./combineRefs-c9ad2c39.js";
import "./useOnClickOutside.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./useMediaQuery.js";
import "./iconButton.js";
import "./getMetrics-953aa4f8.js";
import "./button.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./string-trim-14e37ad3.js";
import "./aria.js";
import "./popupTip-06ee114c.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./useWindowSize.js";
import "./divider.js";
import "./closeButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.parse-int-d7709701.js";
import "./tooltip.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import "./uniqueId.js";
import "./es.date.to-string-6ed49878.js";
import "./es.global-this-a7f40ce1.js";
import "./string-html-forced-a746405b.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.symbol.description-6025a604.js";
import "./es.string.search-d27ec57a.js";
import "./es.function.bind-b4bdcd4b.js";
import "@ucl/ucl-translation";
import "./helperText.js";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./mediaDisclosureButton.js";
import "./index-f2264f1e.js";
import "./screenReaderOnly.js";
import "./accessibility.js";
import "./text.js";
import "./link.js";
import "./es.string.small-23219181.js";
var X = /* @__PURE__ */ _(F.Content).withConfig({
  displayName: "tabsListstyles__CarouselContent",
  componentId: "sc-14b5qic-0"
})(["&.TabList-CarouselContent{", ";}"], function(e) {
  var t = e.theme.components.tabs;
  return h(t.CarouselContent);
}), G = /* @__PURE__ */ _.div.withConfig({
  displayName: "tabsListstyles__TabsList",
  componentId: "sc-14b5qic-1"
})(["&.TabList{", ";}"], function(e) {
  var t = e.theme.components.tabs;
  return h(t.TabList);
}), H = /* @__PURE__ */ _.div.withConfig({
  displayName: "tabsListstyles__Indicator",
  componentId: "sc-14b5qic-2"
})(["&.TabList__indicator{", ";}"], function(e) {
  var t = e.theme.components.tabs;
  return h(t.Indicator);
}), J = /* @__PURE__ */ _.button.withConfig({
  displayName: "tabsListstyles__Tab",
  componentId: "sc-14b5qic-3"
})(["&.Tab{", ";}"], function(e) {
  var t = e.theme.components.tabs;
  return h(t.Tab);
}), K = /* @__PURE__ */ _.span.withConfig({
  displayName: "tabsListstyles__Label",
  componentId: "sc-14b5qic-4"
})(["&.Tab__label{", ";}"], function(e) {
  var t = e.theme.components.tabs;
  return h(t.Label);
}), M = ["children", "index", "className", "disabled", "onClick", "badgeProp"], k = function(t) {
  var g = t.children, d = t.index, s = d === void 0 ? 0 : d, x = t.className, i = t.disabled, n = t.onClick, C = t.badgeProp, c = B(t, M), m = w($), u = m.activeTabIndex, v = u === void 0 ? 0 : u, T = m.setActiveTabIndex, f = m.size, N = m.badgeProp, L = m.id, y = function(o) {
    i || (T == null || T(s), n == null || n(o));
  }, l = C || N;
  return /* @__PURE__ */ P(J, Object.assign({
    id: "tab-" + L + "-" + s,
    role: "tab",
    onClick: y,
    disabled: i,
    tabIndex: !i && v === s ? 0 : -1,
    className: I(["Tab", "Tab--" + f, {
      "Tab--disabled": i,
      "Tab--active": v === s
    }, x]),
    "aria-controls": "tabpanel-" + L + "-" + s,
    "aria-selected": v === s
  }, c, {
    children: [/* @__PURE__ */ b(K, {
      className: "Tab__label",
      children: g
    }), l && /* @__PURE__ */ b(V, Object.assign({}, l, {
      className: I(["Tab__Badge", l.className]),
      size: f === "small" ? f : "medium"
    }))]
  }));
}, Q = ["children", "centered"], z = function(t) {
  var g = t.children, d = t.centered, s = d === void 0 ? !1 : d, x = B(t, Q), i = W(null), n = w($), C = n.activeTabIndex, c = C === void 0 ? 0 : C, m = n.setActiveTabIndex, u = n.size, v = u === void 0 ? "medium" : u, T = n.borderBottom, f = T === void 0 ? !0 : T, N = n.isBottomBorderFullWidth, L = R(i), y = S(g, {
    tab: z.Item
  }), l = E(y.tab, function(r, o) {
    var a, p;
    return /* @__PURE__ */ q(k, Object.assign({}, r, {
      key: o,
      index: (a = r.index) != null ? a : o,
      className: I(["TabsList__Item", "TabsList__Item-" + ((p = r.index) != null ? p : o), r.className])
    }));
  });
  return O(function() {
    var r;
    if (i.current) {
      var o = (r = i.current) == null ? void 0 : r.querySelectorAll(".TabsList__Item")[c];
      if (o) {
        var a = i.current.closest(".Carousel__content");
        a && c === 0 ? a.scrollLeft = 0 : a && c === l.length - 1 ? a.scrollLeft = a.scrollWidth : o.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest"
        });
        var p = o.offsetWidth, j = o.offsetLeft, A = o.classList.contains("Tab--disabled");
        i.current.style.setProperty("--tabs-indicator-width", A ? "0px" : p + "px"), i.current.style.setProperty("--tabs-indicator-position", "translateX(" + j + "px)");
      }
    }
  }, [c, L, l.length]), /* @__PURE__ */ b(F, {
    centered: s,
    hideControls: !0,
    children: /* @__PURE__ */ b(X, {
      className: "TabList-CarouselContent",
      children: /* @__PURE__ */ P(G, Object.assign({}, x, {
        ref: i,
        role: "tablist",
        className: I(["TabList", "TabList--" + v, x.className, {
          "TabList--borderBottom": f,
          "TabList--fullWidth": N
        }]),
        children: [/* @__PURE__ */ b(D, {
          open: !0,
          navigationType: "arrow-left-right",
          selector: ".Tab",
          disableAutoFocus: !0,
          allowTabDefaults: !0,
          allowNegativeTabFocus: !0,
          disableEnforceFocus: !0,
          onFocusNext: function(o, a, p) {
            m(p);
          },
          onFocusPrevious: function(o, a, p) {
            m(p);
          },
          children: l
        }), /* @__PURE__ */ b(H, {
          className: "TabList__indicator"
        })]
      }))
    })
  });
};
z.Item = k;
export {
  k as Tab,
  z as TabList
};
